import { ORDER_STATUSES } from '../constants';

export const getStatusBadgeStyles = (status?: string): string => {
  // Base classes for all status badges
  const baseClasses = 'px-2.5 py-0.5 text-xs font-medium border';

  switch (status?.toUpperCase()) {
    case 'IN_TRANSIT':
      return `${baseClasses} bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-yellow-900 dark:text-yellow-300 dark:border-yellow-700`;
    case ORDER_STATUSES.COMPLETED:
      return `${baseClasses} bg-green-100 text-green-800 border-green-300 dark:bg-green-900 dark:text-green-300 dark:border-green-700`;
    case ORDER_STATUSES.CANCELLED:
    case ORDER_STATUSES.FAILED:
    case ORDER_STATUSES.ERROR:
    case ORDER_STATUSES.REJECTED:
    case ORDER_STATUSES.RETURNED:
      return `${baseClasses} bg-red-100 text-red-800 border-red-300 dark:bg-red-900 dark:text-red-300 dark:border-red-700`;
    case ORDER_STATUSES.EXPECTED:
      return `${baseClasses} bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-900 dark:text-blue-300 dark:border-blue-700`;
    case ORDER_STATUSES.DRAFT:
      return `${baseClasses} bg-gray-100 text-gray-800 border-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600`;
    case 'AWAITING_NEXT_ATTEMPT':
      return `${baseClasses} bg-orange-100 text-orange-800 border-orange-300 dark:bg-orange-900 dark:text-orange-300 dark:border-orange-700`;
    case 'OUT_FOR_DELIVERY':
      return `${baseClasses} bg-indigo-100 text-indigo-800 border-indigo-300 dark:bg-indigo-900 dark:text-indigo-300 dark:border-indigo-700`;
    case 'ADDRESS_NOT_FOUND':
      return `${baseClasses} bg-purple-100 text-purple-800 border-purple-300 dark:bg-purple-900 dark:text-purple-300 dark:border-purple-700`;
    case 'AT_PICKUP_POINT':
      return `${baseClasses} bg-cyan-100 text-cyan-800 border-cyan-300 dark:bg-cyan-900 dark:text-cyan-300 dark:border-cyan-700`;
    case ORDER_STATUSES.INACTIVE:
      return `${baseClasses} bg-orange-100 text-orange-800 border-orange-300 dark:bg-orange-900 dark:text-orange-300 dark:border-orange-700`;
    case ORDER_STATUSES.MISSING:
      return `${baseClasses} bg-rose-100 text-rose-800 border-rose-300 dark:bg-rose-900 dark:text-rose-300 dark:border-rose-700`;

    default:
      // Fallback style for unknown or undefined statuses
      return `${baseClasses} bg-gray-100 text-gray-800 border-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600`;
  }
};

// Returns only the background color for each status
export const getStatusBackgroundColor = (status?: string): string => {
  switch (status?.toUpperCase()) {
    case 'IN_TRANSIT':
      return 'bg-yellow-300 dark:bg-yellow-900';
    case ORDER_STATUSES.COMPLETED:
      return 'bg-green-300 dark:bg-green-900';
    case ORDER_STATUSES.CANCELLED:
    case ORDER_STATUSES.FAILED:
    case ORDER_STATUSES.ERROR:
    case ORDER_STATUSES.REJECTED:
    case ORDER_STATUSES.RETURNED:
      return 'bg-red-300 dark:bg-red-900';
    case ORDER_STATUSES.EXPECTED:
      return 'bg-blue-300 dark:bg-blue-900';
    case ORDER_STATUSES.DRAFT:
      return 'bg-gray-300 dark:bg-gray-900';
    case 'AWAITING_NEXT_ATTEMPT':
      return 'bg-orange-300 dark:bg-orange-900';
    case 'OUT_FOR_DELIVERY':
      return 'bg-indigo-300 dark:bg-indigo-900';
    case 'ADDRESS_NOT_FOUND':
      return 'bg-purple-300 dark:bg-purple-900';
    case 'AT_PICKUP_POINT':
      return 'bg-cyan-300 dark:bg-cyan-900';
    case ORDER_STATUSES.INACTIVE:
      return 'bg-orange-300 dark:bg-orange-900';
    case ORDER_STATUSES.MISSING:
      return 'bg-rose-300 dark:bg-rose-900';
    // Add more specific statuses as needed
    default:
      // Fallback background for unknown or undefined statuses
      return 'bg-gray-300 dark:bg-gray-700';
  }
};
